<template>
  <div v-if="loading" class="flex justify-center py-16">
    <div class="h-8 w-8 border-4 border-gray-300 border-t-[#0d4169] rounded-full animate-spin"></div>
  </div>
  <div v-else-if="message" class="card-panel mx-4 my-6 p-6 text-center">
    <p class="text-sm text-slate-600">{{ message }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    loading: Boolean,
    message: { type: String, default: '' },
  },
}
</script>
